import { Dimensions } from "react-native";

export const { width: WINDOW_WIDTH, height: WINDOW_HEIGHT } = Dimensions.get('window');
export const { width: SCREEN_WIDTH, height: SCREEN_HEIGHT } = Dimensions.get('screen');
export const DATA_GRID_HEIGHT = WINDOW_HEIGHT * 0.08;
export const DATA_FONT_SIZE = WINDOW_HEIGHT * 0.0165;
export const HEADING_FONT_SIZE = WINDOW_HEIGHT * 0.017;
export const DATA_GRID_BORDER_WIDTH = 2;
export const HEADING_BORDER_WIDTH = 2;
export const MAIN_MENU_BORDER_WIDTH = 4;
export const CONTENT_BORDER_WIDTH = 4;